import { COMMON_TYPE, CommonType } from '@/types/enums';
import ApiService from './ApiService';
import { isPathEk } from '@/utils/routes';

export default class GeneralApi extends ApiService {
    getGeneralSettings(payload) {
        const type = isPathEk(window.location.pathname) ? COMMON_TYPE.EK : COMMON_TYPE.GAS;

        const { noUseToken, ...rest } = payload;

        return this.get('general-settings', { ...rest, type }, { noUseToken: noUseToken === true });
    }

    getPlaceAutoComplete(payload) {
        return this.get('system/locations/place-autocomplete', payload);
    }

    getMyAccount() {
        return this.get('my-account');
    }

    editMyAccount(payload) {
        return this.put('my-account', payload);
    }

    registerCouponForeverEnduser(payload) {
        return this.put('customer/coupons/register', payload);
    }

    getLatLngFromPlaceId(payload) {
        return this.get('system/locations/place-detail', payload);
    }

    getUsersByType(payload) {
        return this.get('system/users/cbx/types', payload);
    }

    getCancelSettings(payload) {
        let type: CommonType | undefined = undefined;
        if (isPathEk(window.location.pathname)) {
            type = COMMON_TYPE.EK;
        } else {
            type = COMMON_TYPE.GAS;
        }
        return this.get('cancel-settings', { ...payload, type });
    }

    // get setting of drop off + mileage km
    getOtherSettings(payload) {
        let type: CommonType | undefined = undefined;
        if (isPathEk(window.location.pathname)) {
            type = COMMON_TYPE.EK;
        } else {
            type = COMMON_TYPE.GAS;
        }
        return this.get('other-settings', { ...payload, type });
    }

    // #region Google map geocode
    getGgmapGeocodeByLatLng(payload) {
        return this.post('ggmaps/geocode', payload);
    }
    // #endregion Google map geocode
}
